import AddToPhotosIcon from '@mui/icons-material/AddToPhotosRounded';
import AutoStoriesIcon from '@mui/icons-material/AutoStoriesRounded';
import BeenhereIcon from '@mui/icons-material/BeenhereRounded';
import HomeIcon from '@mui/icons-material/HomeRounded';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOverRounded';
import SettingsIcon from '@mui/icons-material/SettingsRounded';
import StickyNote2RoundedIcon from '@mui/icons-material/StickyNote2Rounded';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremiumRounded';
import { useFlag } from '@unleash/proxy-client-react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { NavigationLink } from '../../../../../../Contexts/BlackListLinkContextProvider/BlackListLinkContext';
import useHistory from '../../../../../../Hooks/useHistory/useHistory';
import LinkWrapper from './LinkWrapper';
import StyledBox from './styles';

export default function SideMenuLinks(props: { onClose: () => void }) {
  const { onClose } = props;
  const { t } = useTranslation();
  const { t: tPerformance } = useTranslation('performance');
  const { newHistoryState } = useHistory();
  const summarySession = useFlag('summary-session');
  return (
    <StyledBox>
      <LinkWrapper linkKey={NavigationLink.Home}>
        <NavLink
          to="/home"
          className={({ isActive, isPending }) => clsx({ isActive: isActive && !isPending })}
          onClick={() => { onClose(); }}
          state={newHistoryState}
        >
          <>
            <HomeIcon />
            {t('app-bar.home')}
          </>
        </NavLink>
      </LinkWrapper>
      <LinkWrapper linkKey={NavigationLink.Cards}>
        <NavLink
          to="/cards"
          className={({ isActive, isPending }) => clsx({ isActive: isActive && !isPending })}
          onClick={() => { onClose(); }}
          state={newHistoryState}
        >
          <>
            <StickyNote2RoundedIcon />
            {t('home-page.cards.title')}
          </>
        </NavLink>
      </LinkWrapper>
      <LinkWrapper linkKey={NavigationLink.Commands}>
        <NavLink
          to="/commands"
          className={({ isActive, isPending }) => clsx({ isActive: isActive && !isPending })}
          onClick={() => { onClose(); }}
          state={newHistoryState}
        >
          <>
            <RecordVoiceOverIcon />
            {t('home-page.commands.title')}
          </>
        </NavLink>
      </LinkWrapper>
      <LinkWrapper linkKey={NavigationLink.Compliance}>
        <NavLink
          to="/compliance"
          className={({ isActive, isPending }) => clsx({ isActive: isActive && !isPending })}
          onClick={() => { onClose(); }}
          state={newHistoryState}
        >
          <>
            <BeenhereIcon />
            {t('home-page.compliance.title')}
          </>
        </NavLink>
      </LinkWrapper>
      <LinkWrapper linkKey={NavigationLink.Requests}>
        <NavLink
          to="/requests"
          className={({ isActive, isPending }) => clsx({ isActive: isActive && !isPending })}
          onClick={() => { onClose(); }}
          state={newHistoryState}
        >
          <>
            <AddToPhotosIcon />
            {t('menu.content-request')}
          </>
        </NavLink>
      </LinkWrapper>
      <LinkWrapper linkKey={NavigationLink.Performance}>
        <NavLink
          to="/performance"
          className={({ isActive, isPending }) => clsx({ isActive: isActive && !isPending })}
          onClick={() => { onClose(); }}
          state={newHistoryState}
        >
          <>
            <WorkspacePremiumIcon />
            {tPerformance('title')}
          </>
        </NavLink>
      </LinkWrapper>
      {summarySession && (
        <LinkWrapper linkKey={NavigationLink.Sessions}>
          <NavLink
            to="/sessions"
            className={({ isActive, isPending }) => clsx({ isActive: isActive && !isPending })}
            onClick={() => { onClose(); }}
            state={newHistoryState}
          >
            <>
              <AutoStoriesIcon />
              {t('menu.sessions')}
            </>
          </NavLink>
        </LinkWrapper>
      )}
      <LinkWrapper linkKey={NavigationLink.Settings}>
        <NavLink
          to="/settings"
          className={({ isActive, isPending }) => clsx({ isActive: isActive && !isPending })}
          onClick={() => { onClose(); }}
          state={newHistoryState}
        >
          <>
            <SettingsIcon />
            {t('menu.settings')}
          </>
        </NavLink>
      </LinkWrapper>
    </StyledBox>
  );
}
